module.exports = __webpack_public_path__ + "img/lens-150-plus-08.7105871b.png";